/**
 * src/lib/goiYTram.js — nhớ trạm được gợi ý từ lần chấm Điểm sẵn sàng gần
 * nhất, để trang /lo-trinh mở đúng trạm khi người dùng quay lại.
 * Chỉ lưu trong trình duyệt (localStorage), không gửi đi đâu.
 */
const KHOA = "fv:goi-y-tram";
export const KHOA_NGANH = "fv:nganh";

export function luuGoiY(tram) {
  if (typeof window === "undefined") return;
  try {
    const d = new Date();
    const ngay = `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}`;
    window.localStorage.setItem(KHOA, JSON.stringify({ tram, ngay }));
  } catch { /* chế độ riêng tư */ }
}

export function docGoiY() {
  if (typeof window === "undefined") return null;
  try {
    const g = JSON.parse(window.localStorage.getItem(KHOA) || "null");
    return g && Number.isInteger(g.tram) ? g : null;
  } catch {
    return null;
  }
}
